module.exports = __webpack_public_path__ + "img/q60-20.0335689d.png";